import styled from 'styled-components/macro';

export const MainController = styled.div`
    display: flex;
    height: 100%;
`;
